import React, { useCallback, useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import { request } from "../../services/request"
import { Link } from "react-router-dom"
import { LocationData, LocationDataResponse, SubscriptionData, UpdateSubscriptionResponse } from "../../services/authinterface"
import Table, { TableAction } from "../../components/common/Table"
import { useDebounce } from "../../hooks/useDebounce"
import { useDispatch } from "react-redux"
import { changeloaderState } from "../../store/loaderSlice"
import { AppDispatch } from "../../store/store"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
import { donwloadCSV, downloadPDF } from "../../utils/exportFunctions"
import { RemoveIcon, ResetIcon, ViewIcon } from "../../icons/webSvg"
import { omitEmpty } from "../../utils/utils"

const Locations: React.FC = () => {
    // const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const [locations, serLocations] = useState<LocationData[]>([])
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [totalItems, setTotalItems] = useState(100)
    const [search, setSearch] = useState("")
    const debounceText = useDebounce(search, 500)
    const [sort, setSort] = useState("DESC")
    const [sortCol, setSortCol] = useState("createdAt")
    const [selectedRows, setSelectedRows] = React.useState<LocationData[]>([])

    const [allOwners, setAllOwners] = useState<SubscriptionData[]>([])
    const [allLocations, setAllLocations] = useState<any>([])

    const [status, setStatus] = useState("")
    const [owner, setOwner] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")

    const multipleFilters = [
        {
            label: "Status",
            type: "select",
            value: status,
            onChange: (e: any) => setStatus(e.target.value),
            className: "userfilter sensorsList-filter",
            option: [
                { value: "", label: "All" },
                { value: "1", label: "Active" },
                { value: "0", label: "Offline" },
            ],
        },
        {
            label: "Owner",
            type: "select",
            value: owner,
            onChange: (e: any) => setOwner(e.target.value),
            className: "userfilter sensor-owner sensorsList-filter",
            option: [
                { value: "", label: "All" }, // 👈 first option
                ...allOwners.map((item) => ({
                    value: item.userId,
                    label:
                        item.first_name || item.last_name
                            ? `${item.first_name ?? ""} ${item.last_name ?? ""}`.trim()
                            : item.userAccounts?.email ?? "Unknown User",
                })),
            ],
        },
        {
            label: "City",
            type: "select",
            value: city,
            onChange: (e: any) => setCity(e.target.value),
            className: "userfilter sensor-model sensorsList-filter",
            option: [
                { value: "", label: "All" }, // 👈 first option
                ...Array.from(
                    new Map(
                        allLocations
                            .filter((item: any) => item.city && item.city.trim() !== "") // ✅ only valid cities
                            .map((item: any) => [item.city, item]) // ✅ city as key → removes duplicates
                    ).values()
                ).map((item: any) => ({
                    value: item.city,
                    label: item.city,
                })),
            ],
        },
        {
            label: "State",
            type: "select",
            value: state,
            onChange: (e: any) => setState(e.target.value),
            className: "userfilter sensor-model sensorsList-filter",
            option: [
                { value: "", label: "All" }, // 👈 first option
                ...Array.from(
                    new Map(
                        allLocations
                            .filter((item: any) => item.state && item.state.trim() !== "") // ✅ only valid states
                            .map((item: any) => [item.state, item]) // ✅ use state as key (removes duplicates)
                    ).values()
                ).map((item: any) => ({
                    value: item.state,
                    label: item.state,
                })),
            ],
        },
        {
            label: "Reset",
            type: "button",
            onClick: () => {
                setSearch("")
                setStatus("")
                setOwner("")
                setCity("")
                setState("")
            },
            icon: (
                <ResetIcon />
            ),
            className: "resetBtn Sensors-reset sensorsList-filter",
        },
    ]

    const [changeStatus, setChangeStatus] = useState("")
    const [assignOwner, setAssignOwner] = useState("")

    const bulkActions = [
        {
            label: "Change Status",
            type: "select",
            value: changeStatus,
            onChange: (e: any) => setChangeStatus(e.target.value),
            className: "userfilter ",
            option: [
                { value: "", label: "Select Status" , disabled: true},
                { value: "1", label: "Active" },
                { value: "0", label: "Offline" },
            ],
        },
        {
            label: "Assign Owner",
            type: "select",
            value: assignOwner,
            onChange: (e: any) => setAssignOwner(e.target.value),
            className: "userfilter sensor-assign-owner",
            option: [
                { value: "", label: "Select Owner", disabled: true },
                ...allOwners.map((item) => ({
                    value: item.userId,
                    label:
                        item.first_name || item.last_name
                            ? `${item.first_name ?? ""} ${item.last_name ?? ""}`.trim()
                            : item.userAccounts?.email ?? "Unknown User",
                })),
            ],
        },
        {
            label: "Apply",
            type: "button",
            onClick: () => {
                setSearch("")
                setStatus("")
            },
            className: "resetBtn",
        },

        {
            label: "Delete",
            type: "button",
            onClick: () => {
                // setModel("")
                setSearch("")
                setStatus("")
            },
            icon: (
                <RemoveIcon />
            ),

            className: "resetBtn",
        },
        {
            label: `Clear Alert${selectedRows.length > 1 ? "(s)" : ""}`,
            type: "button",
            onClick: () => {
                handleAlert()
            },
            className: "resetBtn",
        },
    ]

    const handleAlert = async () => {
        const params = selectedRows.map((row: any) => row.id)
        try {
          const response = await request({
            url: `/adminCommon/clearLocationsAlert`,
            method: "POST",
            headers: {apikey :process.env.REACT_APP_API_KEY || "gunsens-api"},
            data: params,
          })
          if (response.data) {
            toast.success(response.message)
            fetchLocationData()
            setSelectedRows([])
          } else {
            toast.error(response.message)
          }
        } catch (error: any) {
          toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
        }
    }

    const fetchLocationData = useCallback(async () => {
        try {
            dispatch(changeloaderState(true))
            const params = {
                page: page,
                limit: rowsPerPage,
                search: debounceText,
                sort: sort,
                sortCol: sortCol,
                status: status,
                ownerId: owner,
                city: city,
                state: state
            }
            const response = await request<LocationDataResponse>({
                url: "/adminCommon/getLocations",
                method: "POST",
                data: omitEmpty(params),
            })

            if (response.data) {
                serLocations(response.data)
                setTotalItems(response.total)
            } else {
                toast.error("Failed to fetch: " + response.message)
            }
        } catch (error: any) {
            toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
        } finally {
            dispatch(changeloaderState(false))
        }
    }, [dispatch, page, rowsPerPage, debounceText, status, sort, sortCol, owner, city, state])

    useEffect(() => {
        fetchLocationData()
    }, [page, rowsPerPage, debounceText, sort, fetchLocationData, sortCol, status, owner, sort, city, state])

    const fetchOwners = useCallback(async () => {
        try {
            const params = {
                page: 1,
                limit: 100000,
                search: "",
            }
            const response = await request<UpdateSubscriptionResponse>({
                url: "/adminCustomers/allOwners",
                method: "POST",
                data: params,
            })

            if (response.data) {
                setAllOwners(response.data)
            } else {
                toast.error("Failed to fetch: " + response.message)
            }
        } catch (error: any) {
            toast.error(`Error: ${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
        }
    }, [])

    useEffect(() => {
        fetchOwners()
    }, [fetchOwners])

    const fetchLocations = useCallback(async () => {
        try {
            const response = await request<any>({
                url: "/adminCommon/getAllLocations",
                method: "GET",
            })

            if (response.data) {
                setAllLocations(response.data)
            } else {
                toast.error("Failed to fetch: " + response.message)
            }
        } catch (error: any) {
            toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
        }
    }, [])

    useEffect(() => {
        fetchLocations()
    }, [fetchLocations])

    useEffect(() => {
        if (debounceText) {
            setPage(1)
        }
    }, [debounceText])

    const columns = [
        // {
        //     name: "Customer Name",
        //     value: (location: LocationData) =>
        //         !location?.locationUserAccount?.first_name && !location?.locationUserAccount?.last_name
        //             ? "-"
        //             : (location?.locationUserAccount?.first_name ? location?.locationUserAccount?.first_name : "") +
        //             " " +
        //             (location?.locationUserAccount?.last_name ? location?.locationUserAccount?.last_name : ""),

        //     id: "name",
        // },
        {
            name: "Customer Name",
            value: (location: LocationData) => (
                !location?.locationUserAccount?.first_name && !location?.locationUserAccount?.last_name
                    ? "-"
                    : (
                        <Link className="device-link" to={`/customer/view/${location?.locationUserAccount?.id}`}>
                            {(location?.locationUserAccount?.first_name || "") +
                                " " +
                                (location?.locationUserAccount?.last_name || "")}
                        </Link>
                    )
            ),
            id: "name",
        },
        {
            name: "Location Name",
            value: (location: LocationData) =>
                location?.name,
            id: "name",
        },
        // {
        //     name: "Address",
        //     value: (location: LocationData) =>
        //         location?.address,
        //     id: "address",
        // },
        {
            name: "Address",
            value: (location: LocationData) =>
                location?.latitude && location?.longitude ? (
                    <a
                        href={`https://www.google.com/maps?q=${location.latitude},${location.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                    >
                        {location?.address || "View on Map"}
                    </a>
                ) : (
                    location?.address || "-"
                ),
            id: "address",
            className: "long-text-devices"
        },
        {
            name: "Latitude",
            value: (location: LocationData) =>
                location?.latitude,
            id: "latitude",
        },
        {
            name: "Longitude",
            value: (location: LocationData) =>
                location?.longitude,
            id: "longitude",
        },
        {
            name: "Floor Plan Count",
            value: (location: LocationData) =>
                location?.floorplanCount,
            id: "floorplanCount",
        },
        {
            name: "Sensor Count",
            value: (location: LocationData) =>
                location?.sensorCount,
            id: "sensorCount",
        },
        {
            name: "Status",
            value: (location: LocationData) => (
                <span className="d-flex align-items-center">
                    <span
                        className={`me-2 rounded-circle ${location.status !== "0" ? "bg-success" : "bg-danger"}`}
                        style={{ width: "10px", height: "10px", display: "inline-block" }}
                    ></span>
                    <span>{location.status === "0" ? "Offline" : "Active"}</span>
                </span>
            ),
            // location?.status === "1" ? "Active" : "Inactive",
            id: "Status",
        },
        // {
        //     label: "Bills",
        //     onClick: (row: LocationData) => {
        //       navigate(`/customer/bills/${row.name}`)
        //     },
        //     className: "table-btn-1",
        //   },
    ]

    const action: TableAction[] = [
        {
            label: "",
            // onClick: (row: LocationData) => {
            //     navigate(`/location/view/${row?.id}`)
            // },
            isRedirect: true,
            link: (row: SubscriptionData) => `/location/view/${row?.id}`,
            className: "table-btn-2",
            icon: (
                <ViewIcon />
            ),
        },
        {
            label: "Floors",
            // onClick: (row: LocationData) => {
            //     navigate(`/location/floorPlans/${row.id}`)
            // },
            isRedirect: true,
            link: (row: SubscriptionData) => `/location/floorPlans/${row.id}`,
            className: "table-btn-1",
        },
    ]

    const fetchAllLocations = async () => {
        try {
            const params = {
                page: 1,
                search: debounceText,
                limit: 100000,
                sort: sort,
                sortCol: sortCol,
            };

            const response = await request<LocationDataResponse>({
                url: "/adminCommon/getLocations", // Use the correct URL
                method: "POST",
                data: params,
            });

            if (response.data) {
                return response.data;
            } else {
                toast.error("Failed to fetch all locations: " + response.message);
                return [];
            }
        } catch (error: any) {
            toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`);
            return [];
        }
    };

    const exportCSV = async () => {
        const allData = await fetchAllLocations();

        if (!allData.length) {
            toast.error("No data available to export.");
            return;
        }

        const headers = [
            "Sr No.",
            "Customer Name",
            "Location Name",
            "Latitude",
            "Longitude",
            "Address",
            "Sensor Count",
            "Floor Plan Count",
            "Status",
        ];

        const rows = allData.map((location, index) => [
            index + 1,
            !location?.locationUserAccount?.first_name && !location?.locationUserAccount?.last_name
                ? "-"
                : `${location?.locationUserAccount?.first_name || ""} ${location?.locationUserAccount?.last_name || ""}`,
            location?.name,
            location?.latitude,
            location?.longitude,
            location?.address,
            location?.sensorCount,
            location?.floorplanCount,
            location?.status === "1" ? "Active" : "Inactive",
        ]);

        donwloadCSV(headers, rows, "Locations.csv");
    };

    const exportPDF = async () => {
        const allData = await fetchAllLocations();

        if (!allData.length) {
            toast.error("No data available to export.");
            return;
        }

        const headers = [
            "Sr No.",
            "Customer Name",
            "Location Name",
            "Latitude",
            "Longitude",
            "Address",
            "Sensor Count",
            "Floor Plan Count",
            "Status",
        ];

        const rows = allData.map((location, index) => [
            index + 1,
            !location?.locationUserAccount?.first_name && !location?.locationUserAccount?.last_name
                ? "-"
                : `${location?.locationUserAccount?.first_name || ""} ${location?.locationUserAccount?.last_name || ""}`,
            location?.name,
            location?.latitude,
            location?.longitude,
            location?.address,
            location?.sensorCount,
            location?.floorplanCount,
            location?.status === "1" ? "Active" : "Inactive",
        ]);

        downloadPDF(headers, rows, "Locations");
    };

    return (
        <section className=' dashboard-section dashboard-item '>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />

            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='dashboard-table-title-section'>
                            <h2>Locations</h2>
                            <div className='dashboard-table-title-right-side d-flex gap-2'>
                                <PrimaryButton
                                    label='Export CSV'
                                    className='max-w-max-content'
                                    onClick={exportCSV}
                                />
                                <PrimaryButton
                                    label='Export PDF'
                                    className='max-w-max-content'
                                    onClick={exportPDF}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <div className='table-container-main'>
                            <div className='table-details-section'></div>
                            <Table
                                rowData={locations}
                                columns={columns}
                                action={action}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                totalItems={totalItems}
                                setSortColumn={setSortCol}
                                setSortOrder={setSort}
                                sortColumn={sortCol}
                                sortOrder={sort}
                                isSearch
                                search={search}
                                setSearch={setSearch}
                                multipleFilters={multipleFilters}
                                {...(selectedRows.length > 0 && { bulkActions })}
                                setSelected={setSelectedRows}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Locations
